import axiosInstance from "./axios";

export const apiClient = {
  get: async <T>(url: string, params?: Record<string, unknown>): Promise<T> => {
    const res = await axiosInstance.get(url, { params });
    return res.data;
  },

  post: async <T>(url: string, data?: Record<string, unknown>): Promise<T> => {
    const res = await axiosInstance.post(url, data);
    return res.data;
  },

  put: async <T>(url: string, data?: Record<string, unknown>): Promise<T> => {
    const res = await axiosInstance.put(url, data);
    return res.data;
  },
  
  patch: async <T>(url: string, data?: Record<string, unknown>): Promise<T> => {
    const res = await axiosInstance.patch(url, data);
    return res.data;
  },

  delete: async <T>(url: string): Promise<T> => {
    const res = await axiosInstance.delete(url);
    return res.data;
  },
};